import axios from 'axios';

const BASE_URL = '/api/ts/farmers';

interface FormData {
  fruit: string;
  weight: number;
  tss: number;
  ph: number;
  remarks: string;
  qrId: string;
  image?: File;
}

interface ResponseData {
  data: any[];
}

export interface Farmer {
  id: number;
  name: string;
}

export class FarmerService {
  // Get the token from localStorage or wherever it's stored
  private static getAuthToken() {
    return localStorage.getItem('token'); // Adjust based on your storage choice
  }

  // Fetch farmers for the logged-in user
  static async fetchFarmers(): Promise<ResponseData> {
    try {
      const token = this.getAuthToken(); // Get token
      const response = await axios.get(`${BASE_URL}`, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth': token || '',
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('Failed to fetch data');
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || 'Error fetching data';
      throw new Error(errorMessage);
    }
  }

  static async createFarmer(newFarmerData: any) {
    try {
      const token = this.getAuthToken(); // Get token
      const response = await axios.post(BASE_URL, newFarmerData, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth': token || '',
        },
      });
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error('Failed to submit data');
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || 'Error submitting data';
      throw new Error(errorMessage);
    }
  }
}
